module.exports = __webpack_public_path__ + "files/a888b1494ac29acd924f1ec5fb6191c1.svg";